module.exports = __webpack_public_path__ + "media/images/mobile/solutions/3-271110ff640622ce69fb8bd3ec5f73e1.jpg";